export const themeConfig: any = {
  token: {
    // Seed Token，影响范围大
    colorPrimary: '#ED5736',
    // colorPrimary: 'red',
    borderRadius: 10
    // borderRadius: 2,
    // 派生变量，影响范围小
    // colorBgContainer: '#e8d7d0',
  }
  // components: {
  //   Tabs: {
  //     inkBarColor: '#ED5736',
  //     itemColor:'#ED5736'
  //   },
  // }
}
